import MoreVertIcon from '@material-ui/icons/MoreVert';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

export const MoreIcon = styled(MoreVertIcon)`
    :hover {
        cursor: pointer;
    }
`

export const useStyles = makeStyles((theme) => ({
    paper: {
        zIndex: 100000,
        position: 'absolute'
    },
}));

export const FixButton = styled(Button)`
    padding-left: 6px!important;
    text-transform: capitalize!important;
    border-radius: 0px!important;
    width: 160px!important;
    box-shadow: 1px 4px 5px #888 !important;
`
